import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid, Button, ButtonGroup, Menu, MenuItem, ListItemText } from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import CalendarTodayIcon from '@material-ui/icons/CalendarTodayOutlined';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const useStyles = makeStyles(theme => ({
  root: {},
  calendar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  calendarButton: {
    backgroundColor: theme.palette.common.white
  },
  dropdownButton: {
    backgroundColor: theme.palette.common.white
  },
  calendarTodayIcon: {
    marginRight: theme.spacing(1)
  }
}));

function Header({ className, ...rest }) {
  const classes = useStyles();
  const stateRef = useRef(null);
  const [states, setStates] = useState(null);
  const [openState, setOpenState] = useState(false);
  const [selectEdge, setSelectEdge] = useState(null);
  const [calendarDate, setCalendarDate] = useState(moment());
  const open = Boolean(selectEdge);

  useEffect(() => {
    let assigned_constituencies = JSON.parse(localStorage.getItem('assigned_constituencies'));
    let states = assigned_constituencies.map(item => item.state_display_name);
    setStates(states);
  },[])

  const handleStateOpen = () => {
    setOpenState(true);
  };

  const handleStateClose = () => {
    setOpenState(false);
  };

  const handleStateSelect = (value) => {
    rest.stateHandle(value);
    setOpenState(false);
  };

  const handleCalendarOpen = (edge) => {
    setSelectEdge(edge);
  }

  const handleCalendarChange = (date) => {
    setCalendarDate(date);
  }

  const handleCalendarClose = () => {
    setCalendarDate(moment());
    setSelectEdge(null);
  }

  const handleCalendarAccept = (date) => {
    setCalendarDate(moment());

    if (selectEdge === 'start') {
      rest.setStartDate(date);

      if (moment(date).isAfter(rest.endDate)) {
        rest.setEndDate(date);
      }
    } else {
      rest.setEndDate(date);

      if (moment(date).isBefore(rest.startDate)) {
        rest.setStartDate(date);
      }
    }

    setSelectEdge(null);
  }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        container
        justify="space-between"
        spacing={3}
      >
        <Grid
          item
          lg={4}
          xs={12}
        >
          <Typography
            component="h2"
            gutterBottom
            variant="overline"
            style={{textTransform: 'none', marginBottom: '5%'}}
          >
            Analytics
          </Typography>
          <Typography
            component="h1"
            gutterBottom
            variant="h3"
            style={{marginBottom: '5.5%'}}
          >
            SNAPSHOT
          </Typography>
        </Grid>
        <Grid
          className={classes.calendar}
          item
          lg={8}
          xs={12}
        >
          <ButtonGroup
            variant="contained"
            style={{marginRight: '3%'}}
          >
            <Button 
              className={classes.dropdownButton}
              style={{textTransform: 'none'}}
              onClick={handleStateOpen}
              ref={stateRef}
            >
              {rest.state}
              <ArrowDropDownIcon />
            </Button>
            <Menu
              anchorEl={stateRef.current}
              className={classes.menu}
              onClose={handleStateClose}
              open={openState}
              elevation={1}
            >
              {states && states.map(
                (option) => (
                  <MenuItem
                    className={classes.menuItem}
                    key={option}
                    onClick={() => handleStateSelect(option)}
                  >
                    <ListItemText primary={option} />
                  </MenuItem>
                )
              )}
            </Menu>
          </ButtonGroup>
          <ButtonGroup
            variant="contained"
          >
            <Button
              className={classes.calendarButton}
              onClick={() => handleCalendarOpen('start')}
            >
              <CalendarTodayIcon className={classes.calendarTodayIcon} />
              {rest.startDate.format('DD MM YYYY')}
            </Button>
            <Button
              className={classes.calendarButton}
              onClick={() => handleCalendarOpen('end')}
            >
              <CalendarTodayIcon className={classes.calendarTodayIcon} />
              {rest.endDate.format('DD MM YYYY')}
            </Button>
          </ButtonGroup>
        </Grid>
      </Grid>
      <DatePicker
        maxDate={moment()}
        onAccept={handleCalendarAccept}
        onChange={handleCalendarChange}
        onClose={handleCalendarClose}
        open={open}
        style={{ display: 'none' }} // Temporal fix to hide the input element
        value={calendarDate}
        variant="dialog"
      />
    </div>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

Header.defaultProps = {};

export default Header;
